import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Grid,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function ServiceModal({ open, onClose }) {
    const navigate = useNavigate();
  const [servicesList, setServicesList] = useState([]);
  const [selectedService, setSelectedService] = useState(null);

  const handleProceed = () => {
    if (selectedService) {
      onClose();
      localStorage.setItem("serviceId", selectedService);
      navigate(`/registrationform`);
    }
  };

  useEffect(() => {
    fetch(`${API_ENDPOINT}services`)
      .then((response) => response.json())
      .then((data) => {
        const firstTwo = data.slice(0, 2);
        setServicesList(firstTwo);
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
      });
  }, []);

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth 
      maxWidth="sm"
      PaperProps={{
      sx: {
        borderRadius: "20px",
      },
    }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
         // p: 1,
        }}
      >
        <IconButton aria-label="close" onClick={onClose} color="inherit">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </Box>

      <DialogContent>
        {/* Title with image */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        mb: 2,
      }}
    >
      <Box
        component="img"
        src="SAPImages/confirmationpopup/Study Idea 1.png"
        alt="Path to Success"
        sx={{
          width: 60,
          height: 60,
          opacity: 1,
        }}
      />
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 400,
          fontSize: "24px",
          lineHeight: "100%",
          letterSpacing: "0%",
          textAlign: "center",
          color: '#8A40B5'
        }}
      >
        Choose Your Path to Success !
      </Typography>
      </Box>

      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "100%",
          textAlign: "center",
          color: "#555", 
          mb: 3
        }}
      >
        Select the service you’re most interested in. This helps us tailor your
        experience.
      </Typography>
    

        <Grid container spacing={2}>
  {servicesList.map((test) => (
    <Grid item xs={12} sm={6} md={6} key={test.id}>
      <Button
        fullWidth
        onClick={() => setSelectedService(test.id)}
        sx={{
          borderRadius: "8px",
          boxShadow: "0px 0px 10px 0px #0000001A",
          color: selectedService === test.id ? "#fff" : "#000",
          backgroundColor:
            selectedService === test.id ? "#5E168C" : "#fff",
          "&:hover": {
            backgroundColor:
              selectedService === test.id ? "#5E168C" : "#f5f5f5",
          },
          textTransform: "none",
          fontFamily: "Inter",
          py: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        {/* Service Image */}
        <Box
          component="img"
          src={test.id == 1 ? "/SAPImages/confirmationpopup/Group 1171283430.png": "/SAPImages/confirmationpopup/Group 1171283430 (1).png"}
          alt={test.service_name}
          sx={{
            width: 42,
            height: 42,
            opacity: 1,
          }}
        />

        {/* Service Title */}
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "100%",
            textAlign: "center",
            color: selectedService === test.id ? "#fff" : "#9D0385",
          }}
        >
          {test.service_name}
        </Typography>

        {/* Service Description */}
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "100%",
            textAlign: "center",
            color: selectedService === test.id ? "#f0f0f0" : "#444",
          }}
        >
          {test.id == 1 ? "Prepare for IELTS, TOEFl, GRE and More with our expert support." : "Get guidance for application, scholarship and admission abroad."}
        </Typography>
      </Button>
    </Grid>
  ))}
</Grid>

      </DialogContent>
      {/* Proceed button */}
      <DialogActions 
          sx={{ 
            px: 3,
             pb: 3,
             display: "flex",
            justifyContent: "center",
            }}>
        <Button
          variant="contained"
          disabled={!selectedService}
          onClick={handleProceed}
          sx={{
            borderRadius: "8px",
            backgroundColor: "#572575",
            "&:hover": {
              backgroundColor: "#4A116D",
            },
            textTransform: "none",
            fontWeight: 600,
            px: 4,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
          component="img"
          src="/SAPImages/confirmationpopup/material-symbols-light_lock.png" 
          alt="Proceed Icon"
          sx={{
            width: 20,
            height: 20,
          }}
        />
          Confirm & Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ServiceModal;
